// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-container {
  display: flex;
  flex-direction: column;
  width: 22%;
}
.field-name span {
  color: var(--validationError);
}
.css-dg855x-MuiFormControl-root-MuiTextField-root input {
  width: auto !important;
}
.field-container .input,
.select {
  justify-content: center;
  outline: none;
  background: var(--white);
  border-radius: 100px !important;
  height: 40px;
  /* padding-left: 15px; */
  border: 1px solid #c5c5c7;
  margin-top: 13px;
}
.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.MuiPaper-root {
  margin-top: 10px !important;
  border-radius: 6px !important;
  max-width: 260px !important;
  overflow: hidden !important;
}
.MuiPaper-root ul {
  overflow: auto;
  max-height: 327px;
}
.MuiPaper-root li,
.select .MuiSelect-select {
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  text-align: left;
}
.MuiPaper-root li span {
  text-wrap: auto;
}
.optimum-plan .fields .select {
  overflow: hidden;
  cursor: pointer;
  justify-content: left;
}
/* .optimum-plan .fields div:nth-of-type(5) {
  position: absolute;
  bottom: 30px;
  right: 62px;
} */
.optimum-plan .fields div:nth-of-type(2) {
  width: 22%;
}

.customer-info .fields .field-container {
  width: 260px;
}
/* .field-container .input input {
  padding: 0;
} */
.select .MuiSelect-select {
  min-height: 0px !important;
  padding: 0px !important;
  height: 100% !important;
  padding-left: 15px !important;
  display: flex;
  align-items: center;
  width: calc(100% - 17px);
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.select .MuiSelect-select p,
.select .MuiSelect-select span,
.css-1rju2q6-MuiButtonBase-root-MuiMenuItem-root p,
.css-1rju2q6-MuiButtonBase-root-MuiMenuItem-root span {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.selected-value {
  width: calc(100% - 28px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.select fieldset {
  border: 1px solid var(--grey) !important;
}
.field-container .select {
  position: relative;
  appearance: none; /* Hide default arrow */
  /* padding-right: 30px; Space for custom arrow */
}

.btn.go-btn {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 36px;
  right: 4px;
}
.btn.go-btn img {
  width: 18px;
}
.field-container .select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center; /* Adjust position */
  background-size: 20px;
}
.dashboard-menu-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* .menu-items {
  overflow: auto;
  max-height: 327px;
} */

/* Target the entire scrollbar */
::-webkit-scrollbar {
  width: 10px; /* Width of the vertical scrollbar */
  height: 12px; /* Height of the horizontal scrollbar */
}

/* Background of the scrollbar track */
::-webkit-scrollbar-track {
  background: #f1f1f1; /* Light gray */
  border-radius: 10px;
}

/* Scrollbar thumb (the draggable part) */
::-webkit-scrollbar-thumb {
  background: #888; /* Darker gray */
  border-radius: 10px;
}

/* Scrollbar thumb on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* Even darker gray */
}
.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
  -webkit-text-fill-color: rgba(0, 0, 0, 0.87) !important;
}
@media screen and (max-width: 991px) {
  .field-container {
    min-width: 197px;
  }
}

@media screen and (max-width: 767px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardFileds/dashboardFileds.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,+BAA+B;EAC/B,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;;;;GAIG;AACH;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;;GAEG;AACH;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,uDAAuD;AACzD;AACA;;;;EAIE,uDAAuD;AACzD;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,gBAAgB,EAAE,uBAAuB;EACzC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAA0D;EAC1D,4BAA4B;EAC5B,sCAAsC,EAAE,oBAAoB;EAC5D,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;GAGG;;AAEH,gCAAgC;AAChC;EACE,WAAW,EAAE,oCAAoC;EACjD,YAAY,EAAE,uCAAuC;AACvD;;AAEA,sCAAsC;AACtC;EACE,mBAAmB,EAAE,eAAe;EACpC,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB,EAAE,gBAAgB;EAClC,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB,EAAE,qBAAqB;AACzC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;AACA","sourcesContent":[".field-container {\n  display: flex;\n  flex-direction: column;\n  width: 22%;\n}\n.field-name span {\n  color: var(--validationError);\n}\n.css-dg855x-MuiFormControl-root-MuiTextField-root input {\n  width: auto !important;\n}\n.field-container .input,\n.select {\n  justify-content: center;\n  outline: none;\n  background: var(--white);\n  border-radius: 100px !important;\n  height: 40px;\n  /* padding-left: 15px; */\n  border: 1px solid #c5c5c7;\n  margin-top: 13px;\n}\n.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n.MuiPaper-root {\n  margin-top: 10px !important;\n  border-radius: 6px !important;\n  max-width: 260px !important;\n  overflow: hidden !important;\n}\n.MuiPaper-root ul {\n  overflow: auto;\n  max-height: 327px;\n}\n.MuiPaper-root li,\n.select .MuiSelect-select {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17.64px;\n  text-align: left;\n}\n.MuiPaper-root li span {\n  text-wrap: auto;\n}\n.optimum-plan .fields .select {\n  overflow: hidden;\n  cursor: pointer;\n  justify-content: left;\n}\n/* .optimum-plan .fields div:nth-of-type(5) {\n  position: absolute;\n  bottom: 30px;\n  right: 62px;\n} */\n.optimum-plan .fields div:nth-of-type(2) {\n  width: 22%;\n}\n\n.customer-info .fields .field-container {\n  width: 260px;\n}\n/* .field-container .input input {\n  padding: 0;\n} */\n.select .MuiSelect-select {\n  min-height: 0px !important;\n  padding: 0px !important;\n  height: 100% !important;\n  padding-left: 15px !important;\n  display: flex;\n  align-items: center;\n  width: calc(100% - 17px);\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n.select .MuiSelect-select p,\n.select .MuiSelect-select span,\n.css-1rju2q6-MuiButtonBase-root-MuiMenuItem-root p,\n.css-1rju2q6-MuiButtonBase-root-MuiMenuItem-root span {\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n.selected-value {\n  width: calc(100% - 28px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.select fieldset {\n  border: 1px solid var(--grey) !important;\n}\n.field-container .select {\n  position: relative;\n  appearance: none; /* Hide default arrow */\n  /* padding-right: 30px; Space for custom arrow */\n}\n\n.btn.go-btn {\n  width: 32px;\n  height: 32px;\n  position: absolute;\n  top: 36px;\n  right: 4px;\n}\n.btn.go-btn img {\n  width: 18px;\n}\n.field-container .select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"../../assets/icons/arrow-down.svg\");\n  background-repeat: no-repeat;\n  background-position: right 14px center; /* Adjust position */\n  background-size: 20px;\n}\n.dashboard-menu-item {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* .menu-items {\n  overflow: auto;\n  max-height: 327px;\n} */\n\n/* Target the entire scrollbar */\n::-webkit-scrollbar {\n  width: 10px; /* Width of the vertical scrollbar */\n  height: 12px; /* Height of the horizontal scrollbar */\n}\n\n/* Background of the scrollbar track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Light gray */\n  border-radius: 10px;\n}\n\n/* Scrollbar thumb (the draggable part) */\n::-webkit-scrollbar-thumb {\n  background: #888; /* Darker gray */\n  border-radius: 10px;\n}\n\n/* Scrollbar thumb on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Even darker gray */\n}\n.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n.css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {\n  -webkit-text-fill-color: rgba(0, 0, 0, 0.87) !important;\n}\n@media screen and (max-width: 991px) {\n  .field-container {\n    min-width: 197px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
